import moment from "moment";

moment.locale("nl");

export const formatDateToShortString = (date: any) => {
    let dateMoment = moment(new Date(date)).format("DD-MM-YY HH:mm:ss")
    return dateMoment;
}
